import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'freeCardCouponRewards',
  pure: true
})
export class FreeCardCouponRewardsPipe implements PipeTransform {
  transform(coupons: { count: number, value: number }[]): string {
    if (!coupons || coupons.length === 0) return '';

    // Construction des parties ("1 coupon de 25€", ...)
    const parts = coupons.map(({ count, value }) =>
      `${count} coupon${count > 1 ? 's' : ''} de ${value}`
    );

    // Gestion de la ponctuation et concaténation naturelle
    if (parts.length === 1) return parts[0];
    if (parts.length === 2) return `${parts[0]} et ${parts[1]}`;
    // Plusieurs éléments : virgule + "et" avant le dernier
    return parts.slice(0, -1).join(', ') + ' et ' + parts[parts.length - 1];
  }
}
